import { connect } from 'react-redux';

import { logOut } from '@zippeditoolsjs/heimdal-react';

import { getUserCosmetics } from 'core/slices/users';

import { hasSession, userInfo, isLoadingSession, getUserCosmeticsData, isLoadingUserCosmetics } from 'core/selectors';

import MyMenu from '../../../components/navbar/MyMenu';

export default connect(
  state => ({
    isLoadingSession: isLoadingSession(state),
    hasSession: hasSession(state),
    userInfo: userInfo(state),
    userCosmetics: getUserCosmeticsData(state),
    isLoadingUserCosmetics: isLoadingUserCosmetics(state),
  }),
  { logOut, getUserCosmetics },
)(MyMenu);
